export default __webpack_public_path__ + "static/media/vip-badge.f0637a6c.webp";